"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateTextOverview = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_common_components_1 = require("@desygner/ui-common-components");
const TextStickersView_1 = require("../TextStickersView/TextStickersView");
const CreateTextOverview_style_1 = require("./CreateTextOverview.style");
function CreateTextOverview({ apiConfiguration, textItems, onCreateTextClick, onStickerClick, fallback, }) {
    return ((0, jsx_runtime_1.jsxs)(CreateTextOverview_style_1.StyledContainer, { children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.Grid, { cardType: 'text', assetType: 'text', columns: 1, items: textItems, onClick: onCreateTextClick }), (0, jsx_runtime_1.jsx)(TextStickersView_1.TextStickersView, { apiConfiguration: apiConfiguration, fallback: fallback, onClick: onStickerClick })] }));
}
exports.CreateTextOverview = CreateTextOverview;
//# sourceMappingURL=CreateTextOverview.js.map